import React, { useEffect } from 'react';
import './CookiePolicy.css';

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <main className="cookie-page">
      <div className="container cookie-container">
        <header className="cookie-header">
          <h1>Cookie Policy</h1>
          <p className="cookie-subtitle">
            Scan2Card &ndash; AI-Powered Lead Capture &amp; Business Card Scanner
          </p>
          <p className="cookie-meta">
            Scanbiz Technologies LLP | <a href="https://scan2card.com">scan2card.com</a>
          </p>
          <p className="cookie-meta">
            <strong>Last updated:</strong> 03/07/2026
          </p>
        </header>

        <section className="cookie-intro">
          <p>
            This Cookie Policy explains how <strong>Scanbiz Technologies LLP</strong>{' '}
            (&ldquo;Scanbiz&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo; or
            &ldquo;our&rdquo;) uses cookies and similar technologies on scan2card.com and
            related digital services. This Cookie Policy should be read together with our{' '}
            <a href="/privacy-policy">Privacy Policy</a> and{' '}
            <a href="/terms-conditions">Terms &amp; Conditions</a>.
          </p>
        </section>

        <section id="section-1" className="cookie-section">
          <h2>1. What are cookies?</h2>
          <p>
            Cookies are small text files placed on your device when you visit a website.
            They help the site function, remember your preferences, and understand how
            the site is used. We also use similar technologies such as local storage and
            pixels, which we refer to collectively as &ldquo;cookies&rdquo;.
          </p>
        </section>

        <section id="section-2" className="cookie-section">
          <h2>2. Types of cookies we use</h2>
          <p>We use the following categories of cookies:</p>
          <ul>
            <li>
              <strong>Strictly Necessary Cookies</strong> &ndash; These cookies are
              essential for the operation, security and functionality of the website,
              including user authentication, session management, fraud prevention and
              load balancing. Because these cookies are necessary for the website to
              function, they cannot be disabled through our cookie preference centre.
            </li>
            <li>
              <strong>Functional Cookies</strong> &ndash; These cookies remember your
              preferences and settings in order to enhance your browsing experience.
            </li>
            <li>
              <strong>Analytics Cookies</strong> &ndash; These cookies help us understand
              how visitors interact with our website so that we can improve its
              performance and usability. We may use analytics service providers such as
              Google Analytics or equivalent services.
            </li>
            <li>
              <strong>Marketing Cookies</strong> &ndash; These cookies help us measure
              the effectiveness of marketing campaigns and display relevant content. We
              may use advertising and social media platforms such as Meta, Instagram,
              YouTube or similar providers.
            </li>
          </ul>
          <p>
            Functional, analytics and marketing cookies will be placed on your device
            only after you provide your consent through our cookie banner or preference
            centre.
          </p>
        </section>

        <section id="section-3" className="cookie-section">
          <h2>3. Consent and managing cookies</h2>
          <p>
            When you first visit our website, our cookie banner lets you accept or
            reject non-essential cookies. You can change or withdraw your choice at any
            time through the cookie settings link on our site. Withdrawal of your consent
            will not affect the lawfulness of cookies that were placed on your device
            based on your consent before such withdrawal. You can also control cookies
            through your browser settings and delete cookies already stored; blocking
            some cookies may affect how the site works.
          </p>
        </section>

        <section id="section-4" className="cookie-section">
          <h2>4. Third-party cookies</h2>
          <p>
            Some cookies may be set by third-party services we use (such as analytics or
            embedded content providers). Those third parties process data under their own
            privacy and cookie policies, over which we have no control. Scanbiz does not
            control the placement, operation or retention of cookies set by third-party
            providers and recommends that users review the privacy and cookie policies of
            those providers before interacting with third-party content.
          </p>
        </section>

        <section id="section-5" className="cookie-section">
          <h2>5. Changes and contact</h2>
          <p>
            We may update this Cookie Policy from time to time to reflect changes in
            applicable law, technology or our use of cookies. The latest version will
            always be available on our website and will become effective from the date of
            publication. If you have any questions regarding this Cookie Policy or our
            use of cookies, please contact:
          </p>
          <address>
            Scanbiz Technologies LLP,<br />
            <a href="mailto:aryan@scan2card.com">aryan@scan2card.com</a>,<br />
            <strong>Tel.:</strong> +91 72638 89831
          </address>
        </section>
      </div>
    </main>
  );
};

export default CookiePolicy;
